import { render, staticRenderFns } from "./stopPage.vue?vue&type=template&id=0586c38a&scoped=true&"
import script from "./stopPage.vue?vue&type=script&lang=js&"
export * from "./stopPage.vue?vue&type=script&lang=js&"
import style0 from "./stopPage.vue?vue&type=style&index=0&id=0586c38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0586c38a",
  null
  
)

export default component.exports